import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookiePopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up">
      <div className="container mx-auto max-w-4xl">
        <div className="bg-dark-card border border-dark-border rounded-lg shadow-2xl p-6 glass">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <Cookie className="text-dark-accent w-8 h-8" />
            </div>
            <div className="flex-1">
              <h3 className="text-white font-semibold text-lg mb-2">
                Nous Utilisons des Cookies
              </h3>
              <p className="text-dark-muted text-sm mb-4">
                Nous utilisons des cookies pour améliorer votre expérience, analyser le
                trafic du site et personnaliser le contenu. En continuant à naviguer,
                vous acceptez notre{' '}
                <Link
                  to="/politique-cookies"
                  className="text-dark-accent hover:underline"
                >
                  Politique des Cookies
                </Link>
                .
              </p>
              <div className="flex flex-wrap gap-3">
                <button
                  onClick={handleAccept}
                  className="px-6 py-2 bg-dark-accent hover:bg-dark-accentHover text-white rounded-lg transition-colors font-medium text-sm"
                >
                  Tout Accepter
                </button>
                <button
                  onClick={handleReject}
                  className="px-6 py-2 bg-dark-surface hover:bg-dark-border text-dark-text rounded-lg transition-colors font-medium text-sm border border-dark-border"
                >
                  Refuser
                </button>
              </div>
            </div>
            <button
              onClick={handleAccept}
              className="flex-shrink-0 text-dark-muted hover:text-white transition-colors"
              aria-label="Fermer"
            >
              <X size={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePopup;

